import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 195 66"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M102.5 19.9 94.8 4.2h-1.1l-7.5 15.7H92l2.3-5.7 2.2 5.7h6zM94.3 10z",
  style: {"fill":"#f7177c"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.6.8v30.3l9.3-9.3h8.9l-12.5 12 13.4 16.6h-8.6l-9.5-12.1-1.1 1.1v11H3V.8h6.6zM58.2 37.8H37.6c.2 2.4.9 4.2 2.3 5.6 1.4 1.4 3.1 2.1 5.2 2.1 1.6 0 3-.4 4.1-1.2 1.1-.8 2.3-2.2 3.6-4.4l5.6 3.1c-.9 1.5-1.8 2.7-2.7 3.8-1 1.1-2 1.9-3.1 2.6-1.1.7-2.3 1.2-3.6 1.5-1.3.3-2.7.5-4.2.5-4.3 0-7.7-1.4-10.3-4.1-2.6-2.8-3.9-6.4-3.9-11 0-4.5 1.3-8.2 3.8-11 2.5-2.8 5.9-4.2 10.1-4.2 4.2 0 7.6 1.3 10 4 2.4 2.7 3.7 6.4 3.7 11.1v1.6zm-6.8-5.5c-.9-3.5-3.2-5.3-6.7-5.3-.8 0-1.6.1-2.3.4-.7.2-1.3.6-1.9 1.1-.6.5-1.1 1-1.5 1.7-.4.6-.7 1.4-.9 2.2h13.3zM73.4 45.2 60.5 21.9h7.7L77 38.4l8.2-16.5h7.5L69.8 66.1h-7.6l11.2-20.9z",
  style: {"fill":"#48519e"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "m103.3 21.9 7.4 16.1 7.4-16.1h7.4l-14.9 30.7-14.7-30.7h7.4zM136.7 21.9v16.5c0 4.8 1.9 7.1 5.6 7.1 3.7 0 5.6-2.4 5.6-7.1V21.9h6.6v16.6c0 2.3-.3 4.3-.9 5.9-.5 1.5-1.5 2.8-2.9 4-2.2 1.9-5.1 2.9-8.5 2.9-3.4 0-6.3-1-8.5-2.9-1.4-1.2-2.3-2.5-2.9-4-.5-1.3-.8-3.3-.8-5.9V21.9h6.7zM189 37.8h-20.6c.2 2.4.9 4.2 2.3 5.6 1.4 1.4 3.1 2.1 5.2 2.1 1.6 0 3-.4 4.1-1.2 1.1-.8 2.3-2.2 3.6-4.4l5.6 3.1c-.9 1.5-1.8 2.7-2.7 3.8-1 1.1-2 1.9-3.1 2.6-1.1.7-2.3 1.2-3.6 1.5-1.3.3-2.7.5-4.2.5-4.3 0-7.7-1.4-10.3-4.1-2.6-2.8-3.9-6.4-3.9-11 0-4.5 1.3-8.2 3.8-11 2.5-2.8 5.9-4.2 10.1-4.2 4.2 0 7.6 1.3 10 4 2.4 2.7 3.7 6.4 3.7 11.1v1.6zm-6.8-5.5c-.9-3.5-3.2-5.3-6.7-5.3-.8 0-1.6.1-2.3.4-.7.2-1.3.6-1.9 1.1-.6.5-1.1 1-1.5 1.7-.4.6-.7 1.4-.9 2.2h13.3z",
  style: {"fill":"#00a186"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }